import getUserForUsersArray from '../helpers/getUserForUsersArray'

function moveUnApprovedUserToInView({ input, state }) {
  let newUser = getUserForUsersArray(input, state)
  state.push('users.approved', newUser)
  let unapprovedUsers = state.get('users.unapproved')
  let filters = unapprovedUsers.filter(user => {
    return newUser._id === user._id
  })
  if (filters && filters.length > 0) {
    state.splice('users.unapproved', unapprovedUsers.indexOf(filters[0]), 1)
  }
}

export default moveUnApprovedUserToInView



// WEBPACK FOOTER //
// ./src/modules/user/actions/moveUnApprovedUserToApproved.js